/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HospitalMessage } from './HospitalMessage';
import {
    HospitalMessageFromJSON,
    HospitalMessageFromJSONTyped,
    HospitalMessageToJSON,
    HospitalMessageToJSONTyped,
} from './HospitalMessage';

/**
 * 
 * @export
 * @interface CreateHospitalMessageSync200Response
 */
export interface CreateHospitalMessageSync200Response {
    /**
     * 
     */
    data?: HospitalMessage;
}

/**
 * Check if a given object implements the CreateHospitalMessageSync200Response interface.
 */
export function instanceOfCreateHospitalMessageSync200Response(value: object): value is CreateHospitalMessageSync200Response {
    return true;
}

export function CreateHospitalMessageSync200ResponseFromJSON(json: any): CreateHospitalMessageSync200Response {
    return CreateHospitalMessageSync200ResponseFromJSONTyped(json, false);
}

export function CreateHospitalMessageSync200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHospitalMessageSync200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HospitalMessageFromJSON(json['data']),
    };
}

export function CreateHospitalMessageSync200ResponseToJSON(json: any): CreateHospitalMessageSync200Response {
    return CreateHospitalMessageSync200ResponseToJSONTyped(json, false);
}

export function CreateHospitalMessageSync200ResponseToJSONTyped(value?: CreateHospitalMessageSync200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HospitalMessageToJSON(value['data']),
    };
}

